import React from 'react';
import * as Sentry from '@sentry/react';
import axios, { AxiosError } from 'axios';
import {
  Routes,
  createRoutesFromChildren,
  matchRoutes,
  useLocation,
  useNavigationType
} from 'react-router-dom';

let isSentryEnabled = false;
let userData: { id: number } | null;

export function setupSentry() {
  if (!process.env.REACT_APP_ENV) return;
  if (
    process.env.REACT_APP_SENTRY_DSN &&
    ['stg', 'prd'].includes(process.env.REACT_APP_ENV)
  ) {
    isSentryEnabled = true;
    Sentry.init({
      dsn: process.env.REACT_APP_SENTRY_DSN,
      environment: process.env.REACT_APP_ENV,
      normalizeDepth: 10,
      integrations: [
        Sentry.reactRouterV6BrowserTracingIntegration({
          useEffect: React.useEffect,
          useLocation,
          useNavigationType,
          createRoutesFromChildren,
          matchRoutes
        })
      ]
    });
  }
}

export const SentryRoutes = Sentry.withSentryReactRouterV6Routing(Routes);

export function sentrySetUser(id: number) {
  if (isSentryEnabled) {
    // Sentryにユーザー情報をセット
    userData = { id: id };
  }
}

export function sentryLog(err: Error | AxiosError | string | null | undefined) {
  if (axios.isAxiosError(err)) {
    // AxiosError情報を詳細に取得
    const { message, name, config, code } = err;

    // Data属性がある場合
    let data = 'N/A';
    if (err.response && err.response.data) {
      // string化して格納
      data = JSON.stringify(err.response.data);
    }

    // エラーを作成（これがSentryに送られる）
    const customError = new Error(message);
    customError.name = name;

    // エラー情報をSentryに送信
    Sentry.setUser(userData);
    Sentry.withScope((scope) => {
      scope.setExtra('code', code);
      scope.setExtra('config', config);
      scope.setExtra('data', data);
      Sentry.captureException(customError);
    });
  } else {
    // 非AxiosErrorの場合, そのまま送信
    Sentry.captureException(err);
  }
}
